import { HStack, Text } from '@chakra-ui/react';

import { CalloutBadge } from '@/components/CalloutBadge';
import type { SiteNavBadge } from './siteNavRoutes';

export function SiteNavLinkLabel(props: { label: string; badge?: SiteNavBadge }) {
  if (!props.badge) {
    return <>{props.label}</>;
  }

  return (
    <HStack as='span' spacing={2.5} display='inline-flex' alignItems='center'>
      <Text as='span' lineHeight='1'>
        {props.label}
      </Text>
      <CalloutBadge textSize='inherit'>{props.badge}</CalloutBadge>
    </HStack>
  );
}
